import { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Progress,
  CardFooter,
  Collapse,
  UncontrolledTooltip,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoArrowDown } from "react-icons/go";
import "react-circular-progressbar/dist/styles.css";
import CustomTextProgressbar from "../Charts/CustomTextProgressbar";
import StatusBadge from "../Badges/StatusBadge";

const StudentModule = (props) => {
  const [docDropDownOpen, setDocDropDownOpen] = useState(false);
  const [moduleIsOpen, setModuleIsOpen] = useState(false);

  let modDocstoggle = () => {
    setDocDropDownOpen((prev) => !prev);
  };

  const testExists =
    props.module.isGy25 &&
    (props.module.isFactAndTestModule || props.module.isStandAloneTestModule);
  const factModuleExists =
    !props.module.isGy25 ||
    (props.module.isGy25 &&
      (props.module.isFactAndTestModule || props.module.isFactModule));

  const moduleName =
    props.module.fmId !== null ? props.module.fmName : props.module.name;
  const moduleDescription =
    props.module.fmId !== null
      ? props.module.fmDescription
      : props.module.description;
  const factModuleStatus =
    props.module.fmId !== null ? props.module.fmStatus : props.module.status;
  const factModuleLocked =
    props.module.fmId !== null
      ? props.module.fmIsLocked
      : props.module.isLocked;
  const testModuleLocked = props.module.isGy25
    ? props.module.isLocked
    : props.disabled;
  const showScoreBar =
    (props.module.isGy25 && props.module.isFactAndTestModule) ||
    props.module.isStandAloneTestModule ||
    !props.module.isGy25;

  const { fmLastRun, lastRun } = props.module;
  const parsedLastRun = lastRun && moment(lastRun);
  const parsedFmLastRun = fmLastRun && moment(fmLastRun);

  let latestRun = null;

  if (parsedLastRun && parsedFmLastRun) {
    latestRun = parsedLastRun.isAfter(parsedFmLastRun)
      ? parsedLastRun
      : parsedFmLastRun;
  } else if (parsedLastRun) {
    latestRun = parsedLastRun;
  } else if (parsedFmLastRun) {
    latestRun = parsedFmLastRun;
  }

  const documentItems = (doc) => {
    if (doc.fileUrl) {
      return (
        <DropdownItem key={doc.id}>
          <a href={doc.fileUrl}>{doc.value}</a>
        </DropdownItem>
      );
    } else {
      return (
        <DropdownItem key={doc.id}>
          <a href={doc.value}>{doc.value}</a>
        </DropdownItem>
      );
    }
  };

  const showTooltip = props.module.isGy25 && props.module.isFactAndTestModule;

  return (
    <>
      <Card
        className={`progress-container ${
          moduleIsOpen
            ? "expanded student-module-item my-3"
            : "student-module-item my-3"
        }`}
      >
        <CardBody
          href="#"
          className={
            props.disabled || props.licenseExpired
              ? "student-module-item--body_disabled"
              : "student-module-item--body_enabled"
          }
        >
          <Row>
            <Col xl="9" lg="8" md="5" sm="6">
              <div className="d-flex">
                <CardTitle className="student-module-item--Title">
                  {moduleName}
                </CardTitle>
                <Col className="align-content-center">
                  <span
                    title={props.intl.formatMessage({
                      id: "StatusForFactModule",
                    })}
                  >
                    <StatusBadge status={factModuleStatus} />
                  </span>
                  {props.module.isGy25 && props.module.isFactAndTestModule && (
                    <span
                      title={props.intl.formatMessage({
                        id: "StatusForTestModule",
                      })}
                    >
                      <StatusBadge
                        className="px-1"
                        status={props.module.status}
                        isTestModule={true}
                      />
                    </span>
                  )}
                </Col>
              </div>

              <Row className="mb-4">
                {latestRun && latestRun.isValid() && (
                  <Col className="px-0">
                    <small className="text-muted">
                      <FormattedMessage id="Opened" />
                      <span className="ms-1">{latestRun.fromNow()}</span>
                    </small>
                  </Col>
                )}
              </Row>

              <>
                <Collapse isOpen={moduleIsOpen}>
                  <Row>
                    <Col className="px-0">
                      <span>{moduleDescription}</span>
                    </Col>
                  </Row>
                  <div style={{ width: "70px" }}>
                    <hr />
                  </div>
                  <Row>
                    <Col>
                      {showTooltip && (
                        <>
                          {["activityPoints", "modulePoints"].map((target) => (
                            <UncontrolledTooltip
                              key={target}
                              placement="top"
                              target={target}
                              className="info-tooltip"
                            >
                              <FormattedMessage id="InfoTooltipPointsAndActivityPoints" />
                            </UncontrolledTooltip>
                          ))}
                        </>
                      )}

                      {factModuleExists && (
                        <div
                          className="circular-progress circular-progress_activityPoints me-2"
                          style={{ width: 100, height: 100 }}
                          id={showTooltip && "activityPoints"}
                        >
                          <CustomTextProgressbar
                            percentage={props.calcPercentage(
                              props.module.maxActivityPoints,
                              props.module.activityPoints
                            )}
                            type="activityPoints"
                          >
                            <div>
                              <strong style={{ color: "#404040" }}>
                                {props.module.activityPoints}/
                                {props.module.maxActivityPoints}
                              </strong>
                            </div>

                            <strong className="point-label">
                              {props.intl
                                .formatMessage({
                                  id: "ActivityPoints",
                                })
                                .toLowerCase()}
                            </strong>
                          </CustomTextProgressbar>
                        </div>
                      )}
                      {showScoreBar && (
                        <div
                          className="circular-progress circular-progress_score"
                          style={{ width: 120, height: 120 }}
                          id={showTooltip && "modulePoints"}
                        >
                          <CustomTextProgressbar
                            percentage={props.module.scoreInPercent}
                            type="score"
                          >
                            <div>
                              <strong>{props.module.scoreInPercent}%</strong>
                            </div>
                            <strong className="point-label">
                              {props.intl
                                .formatMessage({
                                  id: "ModulePoints",
                                })
                                .toLowerCase()}
                            </strong>
                          </CustomTextProgressbar>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <span className="font-weight-bold">
                        <FormattedMessage id="ModuleTestDone" />:
                      </span>
                      <span className="mx-1">{props.module.nbrOfAttempts}</span>
                      <span>
                        {props.module.nbrOfAttempts === 1
                          ? props.intl
                              .formatMessage({
                                id: "TimeCount",
                              })
                              .toLowerCase()
                          : props.intl
                              .formatMessage({
                                id: "Times",
                              })
                              .toLowerCase()}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span className="font-weight-bold">
                        <FormattedMessage id="LastOpened" />:
                      </span>
                      <span className="ms-1">
                        {latestRun && latestRun.isValid()
                          ? latestRun.format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </span>
                    </Col>
                  </Row>
                  {props.courseUploads.length > 0 && (
                    <Row className="mt-2">
                      <Col lg={4}>
                        <Dropdown
                          isOpen={docDropDownOpen}
                          toggle={modDocstoggle}
                        >
                          <DropdownToggle
                            color="secondary"
                            className="doc-dropdown-toggle"
                            outline
                            caret
                          >
                            <FormattedMessage id="Documents" />
                          </DropdownToggle>
                          <DropdownMenu className="w-100">
                            {props.courseUploads.map((doc) => {
                              return documentItems(doc);
                            })}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                    </Row>
                  )}
                </Collapse>
                <div className="pb-2">
                  {factModuleExists && (
                    <Row className="horizontal-progress align-items-center">
                      <Col lg="6" className="px-0">
                        <Progress
                          className="progress-student--activitypoints"
                          value={props.calcPercentage(
                            props.module.maxActivityPoints,
                            props.module.activityPoints
                          )}
                          max={100}
                        />
                      </Col>
                      <Col className="flex-grow-0 text-nowrap">
                        <span className="text-muted text-small">
                          <span className="me-1">
                            {props.module.activityPoints}/
                            {props.module.maxActivityPoints}
                          </span>
                          {props.intl.formatMessage({
                            id: "ActivityPoints",
                          })}
                        </span>
                      </Col>
                    </Row>
                  )}
                  {showScoreBar && (
                    <Row className="horizontal-progress align-items-center">
                      <Col lg="6" className="px-0">
                        <Progress
                          className="progress-student--score"
                          value={props.module.score ?? 0}
                          max={props.module.maxScore}
                        />
                      </Col>
                      <Col className="flex-grow-0 text-nowrap">
                        <span className="text-muted score-label">
                          <span>{props.module.scoreInPercent}</span>
                          % <FormattedMessage id="ModulePoints" />
                        </span>
                      </Col>
                    </Row>
                  )}
                </div>
              </>
            </Col>
            <Col className="align-content-center">
              <Row className="me-0 justify-content-end gap-3">
                {factModuleExists && !props.module.isFinalExam ? (
                  <Col className="text-center" style={{ maxWidth: "90px" }}>
                    <div className="d-flex flex-column align-items-center">
                      {(props.disabled ||
                        factModuleLocked ||
                        props.licenseExpired) && (
                        <span
                          title={props.intl.formatMessage({
                            id: "YourTeacherLockedThisModuleError",
                          })}
                          className="module-locked-span"
                        />
                      )}
                      <FontAwesomeIcon
                        icon="play-circle"
                        color="#4f6065"
                        onClick={(event) =>
                          props.disabled ||
                          factModuleLocked ||
                          props.licenseExpired
                            ? null
                            : props.module.fmId != null &&
                              props.module.fmUrl != null
                            ? props.runModule(
                                event,
                                props.module.fmId,
                                props.module.moduleType,
                                props.module.fmUrl
                              )
                            : props.runModule(
                                event,
                                props.module.id,
                                props.module.moduleType,
                                props.module.url
                              )
                        }
                        style={{
                          width: "4em",
                          height: "4em",
                          cursor:
                            props.disabled ||
                            factModuleLocked ||
                            props.licenseExpired
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                      <div className="text-nowrap mt-1">
                        <FormattedMessage id="StartModule" />
                      </div>
                    </div>
                  </Col>
                ) : (
                  <></>
                )}
                {(testExists || props.module.isFinalExam) && (
                  <Col className="text-center" style={{ maxWidth: "90px" }}>
                    <div className="d-flex flex-column align-items-center">
                      {(props.disabled ||
                        testModuleLocked ||
                        props.licenseExpired) && (
                        <span
                          title={props.intl.formatMessage({
                            id: "YourTeacherLockedThisModuleError",
                          })}
                          className="module-locked-span"
                        />
                      )}

                      <img
                        src={
                          props.disabled ||
                          testModuleLocked ||
                          props.licenseExpired
                            ? "img/Locked_exam.svg"
                            : "img/BrainIcon.svg"
                        }
                        alt="Start test"
                        onClick={(event) => {
                          if (!testModuleLocked) {
                            props.runModule(
                              event,
                              props.module.id,
                              props.module.moduleType,
                              props.module.url
                            );
                          }
                        }}
                        style={{
                          width: "4em",
                          height: "4em",
                          cursor:
                            props.disabled ||
                            testModuleLocked ||
                            props.licenseExpired
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                      <div className="text-nowrap mt-1">
                        <FormattedMessage id="StartTest" />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="py-2 px-4 student-module-footer">
          <span
            className="text-muted student-module-more-info"
            onClick={() => setModuleIsOpen(!moduleIsOpen)}
          >
            <FormattedMessage id="MoreInfo" />
            <GoArrowDown
              size={14}
              className={`student-module-dropdown-caret ${
                moduleIsOpen ? "student-module-dropdown-caret-rotated" : ""
              }`}
            />
          </span>
        </CardFooter>
      </Card>
    </>
  );
};
export default injectIntl(StudentModule);
